module.exports = __webpack_public_path__ + "static/img/delivery-owl-dark.842cddba.svg";